// @flow
import { createSelector } from 'reselect';
import { MOUNT_POINT } from './constants';
import type { State } from './reducer';

export const getNetworksState: (state: Object) => State = (state) => state[MOUNT_POINT];

export const getCoordinateSystem: (state: Object) => string = createSelector(
    [getNetworksState], (state) => state.coordinateSystem,
);
